module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tagMappingFormCardContent.AddNewTagAction.right":"Value","tagMappingFormCardContent.CopyValue.right":"Target Key","tagMappingFormCardContent.RemoveTag.right":"Remove"}}')
  delete Component.options._Ctor
}
